module.exports = __webpack_public_path__ + "static/media/993828.3d05ab2a.png";